import React from "react";
import { Radio } from "antd";
import { DESTINATION_TYPE } from "../constants";
import { TranslateText } from "@/utils/translation";
const t = (textKey) => <TranslateText textKey={textKey} namespace="pos" />;
const DestinationCard = ({ destination, selected, onSelect }) => {
  const displayName =
    destination.type === DESTINATION_TYPE.TABLE
      ? destination.data.name
      : destination.data.roomNum;
  return (
    <div
      onClick={() => onSelect(destination)}
      className={`border rounded-md p-3 cursor-pointer transition-all ${
        selected ? "border-primary bg-primary/5" : "hover:border-gray-400"
      }`}
    >
      <div className="flex justify-between items-center">
        <Radio checked={selected}>{displayName}</Radio>

        <p
          className={`text-xs font-medium px-2 py-1 rounded-full  ${
            destination.hasOrder ? "bg-orange-100 text-orange-700" : ""
          }`}
        >
          {destination.hasOrder ? <span>{t("running_order")}</span> : ""}
        </p>
      </div>
    </div>
  );
};

export default DestinationCard;
